import { render, staticRenderFns } from "./policies-dialog.vue?vue&type=template&id=6b341520&scoped=true&"
import script from "./policies-dialog.vue?vue&type=script&lang=ts&"
export * from "./policies-dialog.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/Dashboard/styles/dashboard-dialog.scss?vue&type=style&index=0&id=6b341520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b341520",
  null
  
)

export default component.exports